import { Select, SelectProps } from '@mantine/core';
const options = [
  {
    value: '128',
    label: '128px',
  },
  {
    value: '256',
    label: '256px',
  },
  {
    value: '512',
    label: '512px',
  },
  {
    value: '1024',
    label: '1024px',
  },
  {
    value: '2048',
    label: '2048px',
  },
  {
    value: '4096',
    label: '4096px',
  },
  {
    value: '8192',
    label: '8192px',
  },
  {
    value: 'custom',
    label: 'custom',
  },
];
export function TexturesSelect(props: SelectProps) {
  return <Select data={options} comboboxProps={{ withinPortal: false }} {...props} />;
}
